import DOMPurify from 'dompurify';
import linkifyHTML from 'linkify-html';
import { Opts } from 'linkifyjs';

type EncodedHtml = string;

const linkifyOptions: Opts = {
    target: {
        url: '_blank',
    },
};

export const messageHtmlConverter = (body: string, htmlBody?: EncodedHtml, provenance?: string) => {
    if (provenance === 'mailgun') {
        return linkifyHTML(escapeHTML(body), linkifyOptions);
    }

    return linkifyHTML(toSafeHtml(htmlBody ?? body), linkifyOptions);
};

export const toSafeHtml = (input: string | null | undefined): string => {
    const content = (input ?? '').trim();

    if (looksEscapedHtml(content)) {
        const doc = new DOMParser().parseFromString(content, 'text/html');
        return DOMPurify.sanitize(doc.documentElement.textContent || '');
    }

    if (looksHtml(content)) {
        return DOMPurify.sanitize(content);
    }

    return escapeHTML(content);
};

/** contains escaped HTML ("&lt;p>" or "&lt;div") */
const looksEscapedHtml = (s: string) => /&lt;\/?[a-zA-Z]/.test(s);

/** contains real HTML tags (<p>...</p>) */
const looksHtml = (s: string) => /<\/?[a-z][\s\S]*>/i.test(s);

export const convertSpacesInHtml = (content: string) => {
    return content
        .split(/\r?\n/)
        .map((line) => (line.trim() === '' ? '<p><br></p>' : `<p>${line}</p>`))
        .join('');
};

export const escapeHTML = (text: string): string => {
    const map: { [char: string]: string } = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
    };

    return text.replace(/[&<>"']/g, (char) => map[char]);
};
